import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SenaAuthGuard({ children }) {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      alert('로그인이 필요합니다.');
      navigate('/sena/login');
    }
  }, [token, navigate]);

  if (!token) return null;
  return children;
}
